// Module
var code = "<div> <span ng-transclude></span> <span class=fa-stack ng-click=$ctrl.onToggle()> <i class=\"far fa-square fa-stack-2x\"></i> <i class=\"fas fa-check fa-stack-1x\" ng-if=$ctrl.checked></i> </span> </div> ";
// Exports
module.exports = code;